import React, {useEffect, useState} from 'react';
import {InputText} from "primereact/inputtext";
import "./inputText.scss";
import utils from "utils";

export function InputTextCustomer(props) {
    const [type, setType] = useState(props.type)
    const [value, setValue] = useState(props.value)

    function _handleChange(e) {
        setValue(e.target.value);
        props.onChange(e);
    }




    return (
        <div className="p-inputgroup  span-mrg">
            {props.icon ? <span className="p-inputgroup-addon span-mrg-icon ">
                                          <i className={props.icon}></i>
                            </span> : ''}
            <span className="p-float-label ">
                   <InputText
                    id={props.id}
                    value={value}
                    type={type}
                    name={props.name}
                    onChange={_handleChange}
                    format={props.format}
                    size={props.size}
                    // placeholder={props.placeholder}
                    onFocus={props.onFocus}
                    autocomplete={props.autocomplete}
                    autocapitalize={props.autocapitalize}
                    autocorrect={props.autocorrect}
                    disabled={props.disabled}
                    min={props.min}
                    max={props.max}
                    className={`${props.icon ?
                        ((props.type === 'password' && !props.noShow) ? 'span-mrg-input-p' : 'span-mrg-input') :
                        ((props.type === 'password' && !props.noShow) ? 'span-mrg-input-no-icon-p' : 'span-mrg-input-no-icon')} p-inputtext-trashy`}
                    required={props.required}
                    toggleMask={props.toggleMask}
                    onBlur={props.onBlur}
                />
                <label  htmlFor={props.id}>{props.label}
                    {props.required ? <span className='validate_required'> *</span> : ''}
                    {props.validate ? <span className='validate_required'>{' ' + props.validate}</span> : ''}
            </label>
          </span>
            {props.type === 'password' && !props.noShow ?
                <span className="p-inputgroup-addon span-mrg-icon-p">
                                  <i className={type === 'text' ? "pi pi-eye" : "pi pi-eye-slash"}
                                     onClick={() => {
                                         setType(type === 'text' ? 'password' : 'text')
                                     }}></i>
                            </span> : ''}
        </div>

    );
}